import { handleActions } from "redux-actions";
import { UPLOAD_BUYERS } from "constants/action-types";
import { IBaseStoreState, progressActions } from "reducers/base-reducers";
import { IInvalidUser } from "../actions/upload-buyers-actions";

export interface IUploadBuyersPayload {
    message: string;
    errors?: IInvalidUser[]; // partial success if has non-empty errors
}

export interface IUploadBuyersState extends IBaseStoreState<IUploadBuyersPayload> {
    isUploading: boolean;
}

export const uploadBuyers = handleActions<IUploadBuyersState, IUploadBuyersPayload>(
    {
        ...progressActions<IUploadBuyersPayload, IUploadBuyersState>(UPLOAD_BUYERS.UPLOAD, "isUploading"),
        [UPLOAD_BUYERS.UPLOAD.CANCEL_UPLOADING]: (state) => {
            return { ...state, isUploading: false };
        },
    } as any,
    { isUploading: false, error: null, payload: null }
);
